const DOMAIN = 'cloud.pocketbook.digital'
export const SERVER = 'https://' + DOMAIN
                      //'https://cloud.pocketbook.digital'
export const CLOUD_URL = process.env.NODE_ENV === 'development' ? 'http://localhost:3000' : SERVER + '/browser'
export const SOCKET_URL = process.env.NODE_ENV === 'development' ? 'ws://'+DOMAIN+':8080' : 'wss://'+DOMAIN+'/wss/'

export const URLENCODED = { 'Content-Type': 'application/x-www-form-urlencoded' }
export const API_URL = `${SERVER}/api/v1.0/`
export const googleFontLink = 'https://fonts.googleapis.com/css?family=Lato:400,400i,700|Noto+Sans:400,400i,700|Open+Sans:400,400i,700|PT+Sans:400,400i,700|PT+Serif:400,400i,700|Roboto:400,400i,700&amp;subset=cyrillic'
export const USER_STORAGE_ID = '__pbcloud_user__'
export const REQUEST_LIMIT = 10

export const BOOKMARK_TEXT_LIMIT = 30000

export const highlightColors = {
  'black': '#000',
  'red': '#ff827a',
  'blue': '#56b9ff',
  'green': '#9fdb9d',
  'magenta': '#ff00ff',
  'cian': '#00FFFF',
  'yellow': '#ead036',
  'white': '#fff'
}

export const fontSizes = [14, 16, 18, 24, 36, 48]

export const appearenceSettings = {
  size:  14,
  color: 'white',
  font: 'inherit',
  flow: '2page'
}

export const bgColors = {
  white: {
    bg: '#fff',
    font: '#000'
  },
  very_light_pink: {
    bg: '#e9e9e9',
    font: '#000'
  },
  pale: {
    bg: '#e9e7db',
    font: '#000'
  },
  black: {
   bg: '#fff',
   font: '#fff'
  }
}


// WEBPACK FOOTER //
// ./src/constants.js